<template>
  <div>
    <div class="warehousingPage">
      <template v-if="state == 1">
        <!-- <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
          <van-swipe-item v-for="(item, index) in bannerList" :key="index"
            ><van-image width="100%" height="100%" :src="item"
          /></van-swipe-item>
        </van-swipe> -->

        <div class="formDate">
          <div class="item">
            <div class="tit">采购数量</div>
            <div class="input_box">
              <van-field
                type="number"
                v-model="formData.Quantity"
                placeholder="输入采购数量"
                @focus="inputFocus"
                @blur="inputBlur"
                maxlength="10"
              />
            </div>
          </div>
          <div class="item">
            <div class="tit">价格</div>
            <div class="input_box">
              <van-field
                v-model="formData.Amount"
                placeholder="输入价格"
                @focus="inputFocus"
                @blur="inputBlur"
                maxlength="50"
              />
            </div>
          </div>
          <div class="item">
            <div class="tit">入库商品属性参数记录</div>
            <div class="select_box flex-between margin_b" @click="handleClickOne(6)">
              <van-field
                v-model="attrLabel"
                placeholder="选择属性标签"
                readonly
              />
               <i class="iconfont icon-bottom"></i>
            </div>
            <div class="select_box flex-between" @click="handleClickOne(7)">
              <van-field
                v-model="attrValue"
                placeholder="选择属性值"
                readonly
              />
              <i class="iconfont icon-bottom"></i>
            </div>
          </div>
          <div class="item">
            <div class="tit">采购原因</div>
            <div class="textarea_box">
              <van-field
                type="textarea"
                v-model="formData.PurchaseNote"
                placeholder="请输入采购需求说明"
                @focus="inputFocus"
                @blur="inputBlur"
                maxlength="200"
              />
            </div>
          </div>
          <div class="item">
            <div class="tit">付款形式</div>
            <div class="radio_box">
              <van-radio-group
                v-model="formData.PaymentMethod"
                direction="horizontal"
              >
                <van-radio name="1">先款后货</van-radio>
                <van-radio name="2">货到付款</van-radio>
              </van-radio-group>
            </div>
          </div>
        </div>
        <div class="return_group">
          <div class="primary-button" @click="handleSubmit">提交确认</div>
          <!-- <div class="default-button return" @click="handleReturn">←返回</div> -->
          <div class="primary-button return" @click="handleReturn">
            <i class="iconfont icon-yuyinjiantou"></i> 返回
          </div>
        </div>
      </template>
      <template v-if="state == 2">
        <div class="confirmationInfo">
          <div class="tit">采购信息确认</div>
          <div class="goods_desciption">
            <p class="txt1 fontSize-blueColor-xll">
              商品ID：{{ formData.cmid }}
            </p>
            <p class="txt2 fontSize-blueColor-xll">商品名称：</p>
            <p class="txt3">{{ detail.commodityname }}</p>
            <p class="txt3">{{ detail.commodityname_e }}</p>
            <p class="txt3">{{ detail.commodityname_y }}</p>
            <p class="txt3">{{ detail.commodityname_m }}</p>
            <p class="txt3">{{ detail.commodityname_t }}</p>
            <p class="txt1 fontSize-blueColor-xll">
              SKU采购编码：{{ detail.sku }}
            </p>
            <p class="fontSize-blueColor-xll">ISBN编码： {{ detail.ISBN }}</p>
          </div>
          <div class="goods_other_desciption">
            <div class="good_item">
              <h3>采购数量：</h3>
              <p>{{ formData.Quantity }}</p>
            </div>
            <div class="good_item">
              <h3>采购价格：</h3>
              <p>{{ formData.Amount }}</p>
            </div>
            <div class="good_item">
              <h3>采购原因：</h3>
              <p>{{ formData.PurchaseNote }}</p>
            </div>
          </div>
        </div>

        <div class="return_group">
          <div class="primary-button" @click="queryBtn">确认</div>
          <!-- <div class="default-button return" @click="handleReturn1">←返回</div> -->
          <div class="primary-button return" @click="handleReturn1">
            <i class="iconfont icon-yuyinjiantou"></i> 返回
          </div>
        </div>
      </template>
      <template v-if="state == 3">
        <div class="resultPage">
          <h1>采购申请保存成功</h1>
          <!-- <div class="default-button return" @click="handleReturn">←返回</div> -->
          <div class="primary-button return" @click="handleReturn">
            <i class="iconfont icon-yuyinjiantou"></i> 返回
          </div>
        </div>
      </template>
    </div>

    <van-popup v-model="isShow" position="bottom" :style="{ height: '40%' }">
      <template v-if="popupType == 6">
        <van-picker
          title="请选择属性参数记录"
          show-toolbar
          :columns="attrLabelList"
          @confirm="onConfirm"
          @cancel="isShow = false"
        />
      </template>
      <template v-if="popupType == 7">
        <van-picker
          title="请选择物属性值"
          show-toolbar
          :columns="attrValueList"
          @confirm="onConfirm"
          @cancel="isShow = false"
        />
      </template>
    </van-popup>
  </div>
</template>

<script>
import storage from "../../utils/storage";
import { mapState } from "vuex";
import {
  getAttrLabelList,
  getAttrLabelValue,
  addPurchase,
} from "../../api/api";
export default {
  name: "pManageSet",
  data() {
    return {
      state: 1,
      qyid: 0,
      nowDate: "",
      bannerList: "",

      detail: "", // 商品详情

      isShow: false,
      columns: ["杭州", "宁波", "温州", "绍兴", "湖州", "嘉兴", "金华", "衢州"],
      // 记录类型
      actname: "",
      actnameList: [
        {
          text: "增加",
          value: "add",
        },
        {
          text: "减少",
          value: "reduce",
        },
      ],

      popupType: 1,

      // 属性标签
      attrLabelList: [],
      attrLabel: "",
      // 属性值
      attrValueList: [],
      attrValue: "",

      type: 1, // 1采购入库 2生产入库
      formData: {
        cmid: "",
        SKU: "",
        ISBN: "",
        Brand: "",
        Tags: "",
        TagValues: "",
        Quantity: "",
        Amount: "",
        QuantityReceived: "",
        PaymentMethod: "", // 采购付款方式  =  1 先款后货  2货到付款
        PurchaseNote: "",
        Requester: "",
        OpenType: "", // 申请人的用户类型 = weixin 微信用户，qiye 企业用户 houtai 后台用户 accountid 用户账户id
      },
    };
  },
  computed: {
    ...mapState(["OPENID", "USERINFO"]),
  },
  created() {
    this.getInit();
  },
  methods: {
    // 获得焦点
    inputFocus(e) {
      this.scrollTop = "-" + (e.srcElement.getBoundingClientRect().top - 200);
      this.isShowStyle = true;
    },
    // 失去焦点
    inputBlur() {
      this.isShowStyle = false;
    },

    async getInit() {
      let detailItem = storage.get("GOODDETAIL");
      this.detail = detailItem;
      let bannerList = [];
      bannerList.push(detailItem.banner);
      bannerList.push(detailItem.banner2);
      bannerList.push(detailItem.banner3);
      bannerList.push(detailItem.banner4);
      bannerList.push(detailItem.banner5);
      let filter = bannerList.filter((v) => v != "");
      this.bannerList = filter;
      this.formData.cmid = detailItem.id;
      this.formData.SKU = detailItem.sku;
      this.formData.ISBN = detailItem.ISBN;
      this.formData.Brand = detailItem.brandid;
      this.formData.Requester = this.OPENID;
      this.formData.OpenType = this.USERINFO.accountid
      await this.getAttrLabel();
    },

    handleClickOne(type) {
      let { attrLabel } = this;
      this.popupType = type;
      if (type == 6) {
        this.isShow = true;
      } else if (type == 7) {
        if (attrLabel == "") {
          this.$toast("请选择属性标签");
          return;
        }
        this.isShow = true;
      }
    },

    // 获取属性标签
    getAttrLabel() {
      const Toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      getAttrLabelList().then((res) => {
        let newDate = [];
        res.forEach((v) => {
          if (v.attrstate == "启用") {
            newDate.push({
              value: v.id,
              text: v.attrname,
            });
          }
        });
        this.attrLabelList = newDate;
        Toast.clear();
      });
    },
    // 获取属性值
    getAttrValue(attrid) {
      const Toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      let { cmid } = this.formData;
      getAttrLabelValue({attrid, cmid}).then((res) => {
        let newDate = [];
        res.forEach((v) => {
          if (v.isuse) {
            newDate.push({
              value: v.id,
              text: v.attrvalue,
            });
          }
        });
        this.attrValueList = newDate;
        Toast.clear();
      });
    },

    // 确认弹窗
    onConfirm(e) {
      let { popupType } = this;
      let { value, text } = e;
      if (popupType == 6) {
        this.formData.Tags = text;
        // this.formData.Tags = value
        this.getAttrValue(value);
        this.attrLabel = text;
      } else if (popupType == 7) {
        this.formData.TagValues = text;
        // this.formData.TagValues = value
        this.attrValue = text;
      }
      this.isShow = false;
    },
    handleReturn() {
      history.go(-2);
    },

    handleReturn1() {
      this.state = 1;
    },
    handleSubmit() {
      let { formData } = this;
      if (formData.Quantity == "") {
        this.$toast("请输入采购数量");
        return;
      }
      if (formData.Amount == "") {
        this.$toast("请输入采购金额");
        return;
      }
      if (formData.PurchaseNote == "") {
        this.$toast("请输入采购原因");
        return;
      }
      if (formData.PaymentMethod == "") {
        this.$toast("请选择采购付款方式");
        return;
      }
      this.state = 2;
    },
    queryBtn() {
      let { formData } = this;
      let params = formData;
      const Toast = this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
      });
      addPurchase(params).then((res) => {
        let data = res;
        if (data.result) {
          setTimeout(() => {
            Toast.clear();
            this.$toast.success(data.message);
          }, 2000);
          setTimeout(() => {
            this.state = 3;
          }, 3500);
        } else {
          this.$toast.fail(data.message);
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.warehousingPage {
  padding-bottom: 200px;
  .my-swipe {
    widows: 705px;
    height: 750px;
  }
  .formDate {
    padding: 117px 75px 60px;
    .item {
      margin-bottom: 45px;
      .tit {
        font-size: 30px;
        color: #444444;
        margin-bottom: 28px;
        text-align: center;
      }
      .textarea_box {
        padding: 20px 57px;
      }
      /deep/ .van-cell {
        padding: 0;
        height: 100%;
      }
      /deep/ .van-field__body {
        height: 100%;
      }
      /deep/ .van-field__control {
        height: 100%;
      }
    }
  }
  .confirmationInfo {
    padding: 108px 64px 148px;
    .tit {
      font-size: 50px;
      color: #444444;
      text-align: center;
      margin-bottom: 100px;
    }
    .txt3 {
      font-size: 32px;
    }
  }
  .resultPage {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 35%;
  }
  .resultPage h1 {
    font-weight: 400;
    font-size: 50px;
    color: 50px;
    margin-bottom: 142px;
    text-align: center;
    white-space: nowrap;
  }
}
</style>